import React from "react";
import NewsContainersOutcomesFun from "./NewsContainersOutcomesFun";

const NewsContainersOutcomesList = () => {
  // Moving the categories here to map through them cleanly
  const categories = [
    { id: "events", title: "Events" },
    { id: "eating", title: "Food" },
    { id: "dances", title: "Dances" },
    { id: "influencers", title: "Influencers" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      {categories.map((category) => (
        <NewsContainersOutcomesFun key={category.id} title={category.title} />
      ))}
    </div>
  );
};

export default NewsContainersOutcomesList;
